import React, { FC, useMemo } from 'react'

import { RelatedProducts, RelatedProductsListType } from '@Components/Product/RelatedProducts'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue } from '@Globals/CMS/FieldHelpers'

export interface ProductRecommendationsBlockProps {
  id?: string
  productRecommendationsBlock: Block
}

type ProductRecommendationsBlockData = {
  source: RelatedProductsListType
}

const getBlockData = (recommendationBlock: Block): ProductRecommendationsBlockData => ({
  source: getJSONFieldValue(recommendationBlock.fields || [], 'source') || 'same-category',
})

const ProductRecommendationsBlock: FC<ProductRecommendationsBlockProps> = ({ id, productRecommendationsBlock }) => {
  const { source } = useMemo(() => getBlockData(productRecommendationsBlock), [productRecommendationsBlock])

  return <RelatedProducts id={id} type={source} />
}

export default ProductRecommendationsBlock
